module.exports = __webpack_public_path__ + "img/selected7-min.04096f68.png";